export default __webpack_public_path__ + "static/media/home-design-agency-img-01.b3be9316.png";